export const groupingReportFilter = {
  data () {
    return {
      departmentList: [],
      ownerList: [],
      divisionList: [],
      statusList: []
    }
  },
  methods: {
    getDepartmentList: function () {
      var call = '/getDepartmentList'
      this.$axios.get(call).then(response => {
        this.departmentList = response.data
        this.departmentList.unshift({
          id: 0,
          name: 'Unknown'
        })
      })
    },
    getStatusList: function () {
      this.statusList = [
        {id: 0, name: 'Unknown'},
        {id: 1, name: 'Unknown'},
        {id: 2, name: 'Unknown'},
        {id: 3, name: 'Paritally Approved'},
        {id: 4, name: 'Complete'},
        {id: 5, name: 'In Prepartion'},
        {id: 6, name: 'Raised'},
        {id: 7, name: 'Approved'},
        {id: 8, name: 'Denied'},
        {id: 9, name: 'Denied with Conditions'},
        {id: 10, name: 'Canceled'},
        {id: 11, name: 'Withdrawn'}
      ]
    },
    getOwnerList: function () {
      var call = '/getPEAUserList'
      this.$axios.get(call).then(response => {
        this.ownerList = response.data
        this.ownerList.unshift({
          id: 0,
          name: 'Unknown'
        })
      })
    },
    getDivisionList: function () {
      var call = '/getPEADivisionList'
      this.$axios.get(call).then(response => {
        this.divisionList = response.data
        this.divisionList.unshift({
          id: 0,
          name: 'Unknown'
        })
      })
    },
    changeFilterDisplayType: function (id, type) {
      if (id !== undefined && id !== 'undefined' && id !== '0') {
        if (type === 'department' && this.departmentList.length) {
          for (var k = 0; k < this.departmentList.length; k++) {
            if (this.departmentList[k].id === Number(id)) {
              return type + ': ' + this.departmentList[k].name
            }
          }
        } else if (type === 'status' && this.statusList.length) {
          return type + ': ' + this.statusList[id].name
        } else if (type === 'owner' && this.ownerList.length) {
          for (var j = 0; j < this.ownerList.length; j++) {
            if (this.ownerList[j].id === Number(id)) {
              return type + ': ' + this.ownerList[j].fullName
            }
          }
        } else if (type === 'division' && this.divisionList.length) {
          for (var i = 0; i < this.divisionList.length; i++) {
            if (this.divisionList[i].id === Number(id)) {
              return type + ': ' + this.divisionList[i].name
            }
          }
        } else if (this.isOtherType(type)) return type + ': ' + id
      } else {
        return type + ': All'
      }
    },
    isOtherType: function (type) {
      if (type !== 'department' && type !== 'status' && type !== 'owner' && type !== 'division') {
        return true
      }
    }
  },
  created: function () {
    this.getDepartmentList()
    this.getStatusList()
    this.getOwnerList()
    this.getDivisionList()
  }
}
